import styled, { css } from 'styled-components';

import { CheckboxWrapper } from '../../../../../components/BlueTheme';
import { StyledBlock } from '../../../../Campaigns/Summary/CampaignSummary/CampaignReports/ReportForm/styled';

export const ReportFormContainer = styled.div(
  ({ theme: { spacers } }) => css`
    padding: ${spacers!.spacer04};
    font-family: InspireTWDC;
    overflow-y: auto;
    margin-bottom: ${spacers!.spacer11};
    flex: 1;

    div,
    label,
    span {
      letter-spacing: 0;
    }
  `
);

export const ScheduleReportDescription = styled.div(
  ({ theme: { spacers, admanColors } }) => css`
    padding-bottom: ${spacers!.spacer04};
    font-size: 14px;
    line-height: 21px;
    color: ${admanColors!.gray.dark.fg[7]};
  `
);

export const FormSideBarFooterWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  right: 0;
  background-color: ${({ theme }): string => theme.colors!.colorWhite};
`;

export const FieldContainerStyled = styled.div`
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer04};
  width: 100%;
`;
export const TextFieldContainerStyled = styled(FieldContainerStyled)`
  display: flex;
`;

export const Label = styled.div(
  ({ theme: { spacers, admanColors } }) => css`
    padding-bottom: ${spacers!.spacer01};
    font-size: 14px;
    line-height: 21px;
    color: ${admanColors!.gray.light.fg1[1]};
  `
);

export const CheckboxContainer = styled(CheckboxWrapper)`
  height: 25px;
`;

export const FrequencyContainer = styled.div`
  margin-left: ${({ theme }): string => theme.spacers!.spacer05};
`;

export const StyledWeekdayBlock = styled(StyledBlock)`
  padding-left: 30px;
  max-width: 280px;

  > div > div:nth-child(2) {
    max-width: 250px;
  }
`;

export const DaysSelectorContainer = styled.div(
  ({ theme: { spacers } }) => css`
    margin: ${spacers!.spacer01} 0 ${spacers!.spacer02} ${spacers!.spacer05};
  `
);

export const HintWrapper = styled.div(
  ({ theme: { spacers } }) => css`
    margin-left: ${spacers!.spacer05};
    margin-top: -${spacers!.spacer02};
    margin-bottom: ${spacers!.spacer02};
    font-size: 12px;
    line-height: 18px;
  `
);
